export function canShare(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}

export async function copyText(text: string): Promise<void> {
  await navigator.clipboard.writeText(text);
}

export function isShareCancelled(error: unknown): boolean {
  return error instanceof DOMException && error.name === 'AbortError';
}

export async function shareText(text: string, title?: string): Promise<void> {
  const payload = title ? { title, text } : { text };

  if (!canShare()) {
    throw new Error('Web Share API is not available');
  }

  if (navigator.canShare && !navigator.canShare(payload)) {
    throw new Error('Share data is not supported');
  }

  await navigator.share(payload);
}

/** Prefer system share; fall back to clipboard. Returns how the text was delivered. */
export async function shareOrCopy(
  text: string,
  title?: string,
): Promise<'shared' | 'copied'> {
  if (canShare()) {
    try {
      await shareText(text, title);
      return 'shared';
    } catch (error) {
      if (isShareCancelled(error)) {
        throw error;
      }
    }
  }

  await copyText(text);
  return 'copied';
}
